"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.localStorageProviderKeyRepository = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LocalStorageProviderKeyRepository = function LocalStorageProviderKeyRepository() {
  _classCallCheck(this, LocalStorageProviderKeyRepository);

  _defineProperty(this, "getKeyByKeyId", function (keyId) {
    var key = window.localStorage.getItem(keyId);

    if (!key) {
      return Promise.reject('Key not found.');
    }

    try {
      var provKey = JSON.parse(key);
      return Promise.resolve(provKey);
    } catch (_unused) {
      return Promise.reject('Invalid key.');
    }
  });

  _defineProperty(this, "getKeyByName", function (name) {
    var _keyId = "browser_provkey_".concat(name);

    var key = window.localStorage.getItem(_keyId);

    if (!key) {
      return Promise.reject('Key not found.');
    }

    try {
      var provKey = JSON.parse(key);
      return Promise.resolve(provKey);
    } catch (_unused2) {
      return Promise.reject('Invalid key.');
    }
  });

  _defineProperty(this, "saveKey", function (provKey) {
    var _keyId = "browser_provkey_".concat(provKey.name);

    var _provKey = _objectSpread({
      keyId: _keyId
    }, provKey);

    window.localStorage.setItem(_keyId, JSON.stringify(_provKey));
    return Promise.resolve(_provKey);
  });
};

var localStorageProviderKeyRepository = new LocalStorageProviderKeyRepository();
exports.localStorageProviderKeyRepository = localStorageProviderKeyRepository;